import { Component, OnInit, OnChanges, Input, HostListener, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { SupplierUser } from 'src/app/core/enum/supplier-user.enum';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from 'src/app/shared/services/modal.service';
import { DeleteUserComponent } from 'src/app/components/users/delete-user/delete-user.component';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { AddSupplierUserComponent } from 'src/app/components/users/add-supplier-user/add-supplier-user.component';


@Component({
  selector: 'app-supplier-user',
  templateUrl: './supplier-user.component.html',
  styleUrls: ['./supplier-user.component.scss']
})
export class SupplierUserComponent implements OnInit, OnChanges {
  public filteredSupplierUsers: any[] = [];
  public subuserTitle = '';
  public filteredHeader: string;
  public roleDropDown: boolean;
  public innerWidth: number;
  public minDropDownWidth: any = 540;
  public filterSearch;
  public supplierInfo = SupplierUser.ALL.value;
  public supplierUserRole = [SupplierUser.ALL, SupplierUser.ADMIN, SupplierUser.USER];
  public promptDeleteUser: boolean = false;
  public userToDelete: any;
  public urlPath: any;
  public p: any;


  @Input()
  supplierUsers: any;

  @Input()
  selected: any;

  @Input()
  isMobile: any;

  @Input()
  supplier: any;

  @Output()
  deletedUser = new EventEmitter();

  @Output()
  userCount = new EventEmitter();


  constructor(
    private route: ActivatedRoute,
    private modal: ModalService,
    private header: HeaderService,
    private cdRef: ChangeDetectorRef
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
    this.roleDropDown = this.innerWidth <= this.minDropDownWidth;
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.roleDropDown = this.innerWidth <= this.minDropDownWidth;
    this.urlPath = this.route.snapshot;
  }

  ngOnChanges() {
    this.filterSupplierUsers('all');
  }

  public filterSupplierUsers(filterOption) {
    if (filterOption === 'all') {
      this.filteredSupplierUsers = this.supplierUsers;
    } else {
      this.filteredSupplierUsers = this.supplierUsers.filter(
        supplier => supplier['applications'][0]['roleCode'] === filterOption
      );
    }
    this.subuserTitle = filterOption;
    switch (filterOption) {
      case 'all':
        this.filteredHeader = '';
        break;
      case 'HC_SUPPLIER_ADMIN':
        this.filteredHeader = 'Admin ';
        break;
      case 'HC_SUPPLIER_USER':
        this.filteredHeader = ' ';
        break;
    }
  }

  onAddUser() {
    this.modal.open(AddSupplierUserComponent, { supplierId: this.supplier.id });
  }

  public userRole(user) {
    switch (user['applications'][0]['roleCode']) {
      case 'HC_SUPPLIER_ADMIN':
        return 'Admin';
      case 'HC_SUPPLIER_USER':
        return 'User';
    }
  }

  private removeUser(user) {
    this.filteredSupplierUsers = this.filteredSupplierUsers.filter(item => item !== user);
    this.deletedUser.emit(user);
    this.header.metrics[3].amount = this.filteredSupplierUsers.length;
    this.cdRef.detectChanges();
  }

  public openModal(type, data = null) {
    if (type === 'deleteUser') {
      this.userToDelete = data;
      let subscription = this.modal.closeEvent.subscribe((data) => {
        if (data) {
          this.removeUser(data);
        }
        this.userToDelete = null;
        subscription.unsubscribe();
      })
      this.modal.open(DeleteUserComponent, this.userToDelete)
    } else {

    }
  }


}
